<template>
    <information-content @redirect='redirectLogin'>
        <template slot='title' v-if='account_status'>
            Votre compte a été activé. <br>Vous pouvez désormais vous connecter.
        </template>
        <template slot='title' v-else>
            Votre compte n'a pas pu être activé.<br> Merci de prendre contact avec le support de l'ADEC.
        </template>
        <template slot='label'>
            SE CONNECTER
        </template>
    </information-content>
</template>

<script>
    import InformationContent from '../components/layout/InformationContent';

    export default {
        components: {
            InformationContent},
        name: 'activation',
        data() {
            return {
                account_status: false,
            }
        },
        methods: {
            activate: function() {
                this.$store.dispatch('postApi', {
                    'controller':'PCAuth',
                    'action':'activateAccount',
                    'post': {
                        token: this.$route.params.token,
                    }
                })
                    .then(response => {
                    this.loading = false
                    if(response.data.error === 'auth_not_found') {
                        this.account_status = false
                    }else {
                        this.account_status = true
                    }
                })
            },
            redirectLogin: function (event) {
                this.$router.push({name: 'login'});
            }
        },
        beforeMount(){
            this.activate()
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/Activation.vue